/** True when the server's stats record is for the day already at stats[0]; false for a new day or empty stats. */
const isTodaysRecord = (stats, record) => Boolean(stats && stats[0]) && stats[0].today === record.today;

module.exports = { isTodaysRecord };
